import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';
import { BehaviorSubject, Observable } from 'rxjs';
import { MessageResponse } from 'src/app/Interfaces/MessageResponse';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalaryService {
  dataSource: any;
  $sallary_key =new BehaviorSubject({});
  $Employee_id =new BehaviorSubject({});
  
  $salaryvocabularyId = new BehaviorSubject<number>(0);
  $AllowensemasterId = new BehaviorSubject<number>(0);


  $branshid = new BehaviorSubject<number>(0) 

  $month = new BehaviorSubject<number>(0) 
  private handleError: HandleError;
  customDataSource: CustomStore;
    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler,public NotifyService:NotifyService,
      public translatee: TranslateService) {
      this.handleError = httpErrorHandler.createHandleError('ObjectService');
    }

    submit(name:string){
      const isNotEmpty = (value: any) => value !== undefined && value !== null && value !== ''&& value !== '';
      this.customDataSource = new CustomStore({
        key: 'id',
        load: (loadOptions: any) => {          
          let params = new HttpParams();
          [
            'requireTotalCount',
            'skip',
            'take',
          ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params = params.append(i, JSON.stringify(loadOptions[i]));
            }
  
          });
          return this.http.get(`${environment.apiRoot}/api/${name}/all`, { params: params })
            .toPromise()
            .then((response: any) => {
              return {
                data:name=='EmployeeAllowance'? response.result.data:response.data,
                totalCount:name=='EmployeeAllowance'?response.result.countRecord: response.countRecord,
              };
  
            })
  
            .catch(() => { throw 'Data loading error' });
        },

        insert: (values) => {
          return this.http.post<any>(`${environment.apiRoot}/api/${name}/Add`, values).pipe(  
            // catchError(this.handleError('updateError', values))
          ).toPromise().then((message:MessageResponse)=>{
             this.NotifyService.notifyfun('add')
          })
        },

        update: (key, values) => {
          return this.http.put(`${environment.apiRoot}/api/${name}/Update`, values).toPromise().then(res=>{
            this.NotifyService.notifyfun('edit')
            return res
          },(err=>{
            return err          
          }))
        },
        
        remove: (key) => {
                return this.http.delete(`${environment.apiRoot}/api/${name}/Delete?id=` + encodeURIComponent(key)).toPromise().then((message: MessageResponse) => {
                  this.NotifyService.notifyfun('delete')
        
                })
              }
  
      })


    }

    ApprovedSalaryVocabulary(name:string,data?:{monthNumber?:number,employees?:any,ApprovedStatus:any,safeId?:any}){
      const isNotEmpty = (value: any) => value !== undefined && value !== null && value !== ''&& value !== '';
      let employeesQuery: string ='';
      if(data?.employees) {
        (data?.employees as number[]).forEach(x => {
          employeesQuery += `Employees=${x}&`
        });
      }
      this.customDataSource = new CustomStore({
        key: 'employeeId',
        load: (loadOptions: any) => {          
          let params = new HttpParams();
          [
            'requireTotalCount',
            'skip',
            'take',
          ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params = params.append(i, JSON.stringify(loadOptions[i]));
            }
          });

          return data? 
          this.http.get(`${environment.apiRoot}/api/SalaryVocabulary/${name}?${employeesQuery}MonthNumber=${data.monthNumber}&ApprovedStatus=${data.ApprovedStatus}&safeId=${data.safeId}`)
            .toPromise()
            .then((response: any) => {
              return {
                data:response.data,
                totalCount:response.countRecord,
              };
  
            })
          :
          this.http.get(`${environment.apiRoot}/api/SalaryVocabulary/${name}`)
            .toPromise()
            .then((response: any) => {
              return {
                data:response.data,
                totalCount:response.countRecord,
              };
  
            })
  
            .catch(() => { throw 'Data loading error' });
        }
      })
    }

    PendingSalaryVocabulary(name:string,data?:{monthNumber?:number,employees?:any,branchId?: number,safeId?: number}){
      const isNotEmpty = (value: any) => value !== undefined && value !== null && value !== ''&& value !== '';
      let employeesQuery: string ='';
      if(data?.employees) {
        (data?.employees as number[]).forEach(x => {
          employeesQuery += `Employees=${x}&`
        });
      }
      this.customDataSource = new CustomStore({
        key: 'employeeId',
        load: (loadOptions: any) => {          
          let params = new HttpParams();
          [
            'requireTotalCount',
            'skip',
            'take',
          ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params = params.append(i, JSON.stringify(loadOptions[i]));
            }
          });

          return data? 
          this.http.get(`${environment.apiRoot}/api/SalaryVocabulary/${name}?MonthNumber=${data.monthNumber}&${employeesQuery}SafeId=${data.safeId}&BranchId=${data.branchId}`)
            .toPromise()
            .then((response: any) => {
              return {
                data:response.data,
                totalCount:response.countRecord,
              };
  
            })
          :
          this.http.get(`${environment.apiRoot}/api/SalaryVocabulary/${name}`)
            .toPromise()
            .then((response: any) => {
              return {
                data:response.data,
                totalCount:response.countRecord,
              };
  
            })
  
            .catch(() => { throw 'Data loading error' });
        }
      })
    }

saveEmployeeAbsences(absencesData: any[]): Observable<any> {
  return this.http.post(`${environment.apiRoot}/api/EmployeeAbsence/GetPreSaved`, absencesData);
}

saveAndApproveEmployeeAbsences(absencesData: any[]): Observable<any> {
  return this.http.post(`${environment.apiRoot}/api/EmployeeAbsence/GetSaved`, absencesData);
}
    // EditSalaryVocabulary(data:{}){
    //   return this.http.post<any>(`${environment.apiRoot}/api/SalaryVocabulary/AddPendingSalaryVocabulary`, data).pipe().toPromise().then((message: MessageResponse) => {
    //     this.NotifyService.notifyfun('edit')
    //   })
    // }
      

    filteremployee(id:number){
      return this.http.get(`${environment.apiRoot}/api/Employee/FillterEmployeeById/${id}`)
      }

      filteremployeePermission(id:number){
        return this.http.get(`${environment.apiRoot}/api/EmployeePermission/LoadPermissionData?Employee_Id=${id}`)
        }
   
     addemployee_data(name:string,values:{}){
       return this.http.post<any>(`${environment.apiRoot}/api/${name}/Add`, values)
      }
      editemployee_data(name:string,values:{}){
       return this.http.put(`${environment.apiRoot}/api/${name}/Update`, values)
      }
      
      search(name:string,params:{}){
        return this.http.get(`${environment.apiRoot}/api/${name}/all`, { params: params })
      }
      byKey(name:string,key:number) {
        return this.http.get<any>(`${environment.apiRoot}/api/${name}/GetById/${key}`)
    }
    getextratime_employee_filter(name:string,system:any,month:number){
    return this.http.get(`${environment.apiRoot}/api/Approval/${name}?DurationWorkSystemId=${system}&MonthNumber=${month}&YearNumber=2023`)
    }

    Refresh_Employee(path:string,data:{EmployeeId:number,MonthNumber:number}){
      console.log(data);
      
      return this.http.get(`${environment.apiRoot}/api/${path}?EmployeeId=${data.EmployeeId}&MonthNumber=${data.MonthNumber}`)
      }


      addPendingSallary (data:any) {
        return this.http.post(`${environment.apiRoot}/api/SalaryVocabulary/AddPendingSalaryVocabulary`, data)
      }
getEmployeeAbsence(filterData: any): Observable<any> {
  return this.http.post<any>( `${environment.apiRoot}/api/EmployeeAbsence/GetEmployeeAbsence`, filterData );
}

getEmployeeWorkDurations(filterData: any): Observable<any> {
  return this.http.post<any>( `${environment.apiRoot}/api/AssignEmployeeDuration/GetDurationWorkSystemByFilters`, filterData );
}
      getSallaryStatus () {
        return this.http.get(`${environment.apiRoot}/api/SharedEnums/ApprovedStatusDropDown`)
      }


      AddApprovedSallary (data:any) {
        return this.http.post(`${environment.apiRoot}/api/SalaryVocabulary/AddApprovedSalaryVocabulary`, data)
      }
      getEmployeesExtraTimes (data:any) {
        return this.http.post(`${environment.apiRoot}/api/EmployeeExtraTime/GetExtraTimeFromAttending`, data)
      }

      ///sallay detaisl method component show sallay details
      getAllSallaryDatails(data:any) {
        return this.http.post(`${environment.apiRoot}/api/EmployeeSalaryVocabulary/GetPreSaved`, data)
      }

        salarydetailbyid(id:any) {
        return this.http.get(`${environment.apiRoot}/api/EmployeeSalaryVocabulary/GetById/${id}`)
      }
   
   postBulkRewards(data: any): Observable<any> {
  return this.http.post(`${environment.apiRoot}/api/EmployeeReward/addbulk`, data);
}

postBulkDeductions(data: any): Observable<any> {
  return this.http.post(`${environment.apiRoot}/api/EmployeeDeduction/addbulk`, data);
}

     getTransactionBSSDaily(dateFrom?: string, dateTo?: string) {
       let params = new HttpParams();
       if (dateFrom) {
         params = params.set('DateFrom', dateFrom);
       }
       if (dateTo) {
         params = params.set('DateTo', dateTo);
       }
   
       return this.http.get(`${environment.apiRoot}/api/EmployeeCash/GetTransactionBSSDaily`, { params });
     }
   

     getTransactionCashDaily(dateFrom?: string, dateTo?: string) {
       let params = new HttpParams();
       if (dateFrom) {
         params = params.set('DateFrom', dateFrom);
       }
       if (dateTo) {
         params = params.set('DateTo', dateTo);
       }
   
       return this.http.get(`${environment.apiRoot}/api/EmployeeCash/GetTransactionCashDaily`, { params });
     }

     getAdslSales(dateFrom?: string, dateTo?: string) {
      let params = new HttpParams();
      if (dateFrom) {
        params = params.set('DateFrom', dateFrom);
      }
      if (dateTo) {
        params = params.set('DateTo', dateTo);
      }
  
      return this.http.get(`${environment.apiRoot}/api/EmployeeSales/GetAdslSales`, { params });
    }

    GetMobileSales(dateFrom?: string, dateTo?: string) {
      let params = new HttpParams();
      if (dateFrom) {
        params = params.set('DateFrom', dateFrom);
      }
      if (dateTo) {
        params = params.set('DateTo', dateTo);
      }
  
      return this.http.get(`${environment.apiRoot}/api/EmployeeSales/GetMobileSales`, { params });
    }
    
    GetallDevicesSales(dateFrom?: string, dateTo?: string) {
      let params = new HttpParams();
      if (dateFrom) {
        params = params.set('DateFrom', dateFrom);
      }
      if (dateTo) {
        params = params.set('DateTo', dateTo);
      }
  
      return this.http.get(`${environment.apiRoot}/api/EmployeeSales/allDevicesSales`, { params });
    }

    GetcashSales(dateFrom?: string, dateTo?: string) {
      let params = new HttpParams();
      if (dateFrom) {
        params = params.set('DateFrom', dateFrom);
      }
      if (dateTo) {
        params = params.set('DateTo', dateTo);
      }
  
      return this.http.get(`${environment.apiRoot}/api/EmployeeSales/Getcashsales`, { params });
    }
   
      getEmployeesDelayTimes(data:any):Observable<any>{
        return this.http.post(`${environment.apiRoot}/api/EmployeeDelayTime/GetDelayTime`,data);
      }
saveEmployeeDelayTimes(data:any):Observable<any>{
        return this.http.post(`${environment.apiRoot}/api/EmployeeDelayTime/GetPreSaved`,data);
      }

      saveEmployeeExtraTimes(data:any):Observable<any>{
        return this.http.post(`${environment.apiRoot}/api/EmployeeExtraTime/GetPreSaved`,data);
      }
         approveEmployeeExtraTimes(data:any):Observable<any>{
        return this.http.post(`${environment.apiRoot}/api/EmployeeExtraTime/GetSaved`,data);
      }

approveEmployeeDelayTimes(data:any):Observable<any>{
        return this.http.post(`${environment.apiRoot}/api/EmployeeDelayTime/GetSaved`,data);
      }

      getEmployeeFixedAllowanceAndSalary(data:any):Observable<any>{
        return this.http.post(`${environment.apiRoot}/api/EmployeeAllowance/ExportEmployeeSalaries`,data);
      }

      deleteEmployeeWorkSchedule(request: any): Observable<any> {
  return this.http.delete(`${environment.apiRoot}/api/AssignEmployeeDuration/DeleteEmployeeWorkSchedule`, { body: request });
}
  DeleteEmployeeDeductions(ids: number[]): Observable<any> {
  return this.http.delete(`${environment.apiRoot}/api/EmployeeDeduction/Delete`,{ body: ids  }
  );
}
  }

